import React, { useState } from "react";
import MathExpressionNew from "../common/mathjax";
import { Loader, arrowDownLeft, doubleVIvon, orangeVIcon } from "../../assets/images/index";
import "./test-exercise-card.scss";

export interface ExerciseCardProps {
    t: (key: string) => string;
    exercise: any;
    answers: any[];
    isExerciseLoading: boolean;
    isAnswersLoading: boolean;
    selectedAnswer: number | null;
    correctAnswer?: number | null;
    showFullExercise: boolean;
    onAnswerSelect: (answer_id: number) => void;
    onToggleContent: () => void;
    onShowStatusPopup?: () => void;
    isApprovalStatusVisible?: boolean;
    isPreviewMode?: boolean;
}

const ExerciseCard: React.FC<ExerciseCardProps> = ({
    t,
    exercise,
    answers,
    isExerciseLoading,
    isAnswersLoading,
    selectedAnswer,
    correctAnswer,
    showFullExercise,
    onAnswerSelect,
    onToggleContent,
    onShowStatusPopup,
    isApprovalStatusVisible = false,
    isPreviewMode = false,
}) => {
    return (
        <div className="exercise-card-wrapper">
            {/* Question Section */}
            <div className="question-wrapper">
                <div className="">
                    <div className="approval-wrapper">
                        <h3>{t("exercise")}
                        {isExerciseLoading && <img src={Loader} alt="Loading..." className="inline-loader" />}</h3>
                    </div>

                    {!isExerciseLoading && exercise && (
                        <div className={`exercise-content ${isPreviewMode ? "custom-height" : ""} ${showFullExercise ? "expanded" : "collapsed"}`}>
                            <MathExpressionNew content={exercise.exercise_content} />
                        </div>
                    )}

                </div>

                {!isExerciseLoading && exercise && (
                    <button className="exercise-loader" onClick={onToggleContent}>
                        {showFullExercise ? (
                            <>
                                {t("showLess")}... <img src={arrowDownLeft} alt="Arrow Up" className="arrow-up" />
                            </>
                        ) : (
                            <>
                                {t("loadMore")}... <img src={arrowDownLeft} alt="Arrow Down" />
                            </>
                        )}
                    </button>
                )}
            </div>

            {/* Answer Section */}
            <div className="answer-wrapper">
                <h3>{t("chooseCorrectAnswer")}
                    {isPreviewMode && selectedAnswer === -1 && (
                        <>
                            <span className="divider">•</span>
                            <span className="skipped-text">{t("skippedExercise")}</span>
                        </>
                    )}
                    {isAnswersLoading && <img src={Loader} alt="Loading..." className="inline-loader" />}</h3>
                {!isAnswersLoading && (
                    <div className="exercise-question-items">
                        {answers.map((a, index) => {
                            const isSelected = selectedAnswer === a.answer_id;
                            const isCorrect = correctAnswer === a.answer_id;
                            let className = "exercise-question-item";
                            if (isPreviewMode) {
                                if (isCorrect) className += " success";
                                if (isSelected && !isCorrect) className += " error";
                            } else {
                                if (isSelected) className += " active";
                            }
                            return (
                                <div
                                    key={a.answer_id}
                                    className={className}
                                    onClick={() => !isPreviewMode && onAnswerSelect(a.answer_id)}
                                >
                                    <span>{index + 1}</span>
                                    <MathExpressionNew content={a.answer_content} />
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExerciseCard;
